module.exports = __webpack_public_path__ + "static/img/system_title.b2167ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/system_title.png
// module id = WiCw
// module chunks = 2